import { render } from "./ComponentPresentation.vue?vue&type=template&id=8a4c9022"
import script from "./ComponentPresentation.vue?vue&type=script&lang=js"
export * from "./ComponentPresentation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__